/**
 * Skeleton Components
 * Loading state placeholders that match actual UI layouts
 */

// Base components
export { Skeleton, SkeletonCircle, SkeletonText, SkeletonCard } from './Skeleton';

// Page skeletons
export {
  DashboardSkeleton,
  ChatSkeleton,
  ConversationListSkeleton,
} from './DashboardSkeleton';

export { ContactsSkeleton } from './ContactsSkeleton';
export { TeamsSkeleton, TeamSidebarSkeleton, TeamChatSkeleton } from './TeamsSkeleton';
export { SettingsSkeleton, SettingsSidebarSkeleton, SettingsContentSkeleton } from './SettingsSkeleton';
export { HelpSkeleton } from './HelpSkeleton';
export { NotificationsSkeleton } from './NotificationsSkeleton';
